import styled from '@emotion/styled';

import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';
import { absoluteHeaderHeight } from '../../common/AbsoluteHeader/AbsoluteHeader.styled';

export const LetsHealTogetherScreen = styled.div<{ imgDesktop: string; imgMobile: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  display: flex;

  @media (max-width: ${TabletWidth}px) {
    background-image: url(${({ imgMobile }) => imgMobile});
    background-position: top;
  }
`;

export const LetsHealTogetherContentWrapper = styled.div`
  width: 360px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${TabletWidth}px) {
    height: calc(100% - ${absoluteHeaderHeight}px);
    display: flex;
    flex-direction: column;
    width: auto;
    padding: ${105 + absoluteHeaderHeight}px 24px 0;
  }
`;

export const LetsHealTogetherIntroContentWrapper = styled.div`
  width: 522px;
`;

export const LetsHealTogetherTitle = styled.h3<{ isMain?: boolean }>`
  font-family: Lora;
  font-size: 40px;
  font-weight: 500;
  line-height: 46px;
  color: ${getColor('WHITE')};
  margin-bottom: 28px;
  text-align: ${({ isMain }) => (isMain ? 'center' : 'left')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 32px;
    line-height: normal;
    margin-bottom: 24px;
  }
`;

export const LetsHealTogetherHighlightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LetsHealTogetherCtaContainer = styled.div`
  width: 100%;
  margin-top: 40px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: auto;
  }
`;

export const LetsHealTogetherCtaWrapper = styled.div`
  width: 205px;

  @media (max-width: ${TabletWidth}px) {
    width: auto;
  }
`;
